export const buildCmsScriptLoaderSrc = ({
  portalId
}) => {
  return `/hs/scriptloader/${portalId}.js`;
};